import { render, staticRenderFns } from "./GoodsTeeAdminView.vue?vue&type=template&id=75c2cdc7&"
import script from "./GoodsTeeAdminView.vue?vue&type=script&lang=js&"
export * from "./GoodsTeeAdminView.vue?vue&type=script&lang=js&"
import style0 from "./GoodsTeeAdminView.vue?vue&type=style&index=0&id=75c2cdc7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports